import { useState, useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";

import stl from "./ShareNP.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import faceBookShareIcon from "./images/facebookShare.svg";
import XshareSVG from "./images/XshareSVG";
import WhatsAppSVG from "./images/WhatsAppSVG";
import ShareSvg from "@/pages/post/PostViewComponents/components/InspectionView/imagesSVG/ShareSvg";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import AddToFavoriteButton from "@/common/HOCs/AddToFavorite/AddToFavoriteButton";
import useHelpers from "@hooks/useHelpers";

const ShareNP = (props) => {
  const { t } = useTranslation(["web_post_view", "web_common"]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [CopyDone, setCopyDone] = useState(false);
  const [textToCopy, setTextToCopy] = useState(
    props.postDynamicLink ? props.postDynamicLink : ""
  );
  const { createUrlAbsolute } = useHelpers();

  useEffect(() => {
    setTextToCopy(props.postDynamicLink ? props.postDynamicLink : "");
  }, [props.postDynamicLink]);

  useEffect(() => {
    CopyDone &&
      setTimeout(() => {
        setCopyDone(false);
      }, 3000);
  }, [CopyDone]);
  const copyCodeRef = useRef();
  return props.mobileShare ? (
    <>
      <div
        className={stl.mobileShare}
        onClick={() => {
          setShowPopUp(true);
        }}>
        <ProgressiveImage
          waitUntilInteractive
          className={stl.androidSH}
          src={CDN_LINK + "/assets/images/android_share.svg"}
          alt="icon"
          width={24}
          height={24}
        />
        <img
          className={stl.iosSH}
          src={CDN_LINK + "/assets/images/ios_share.svg"}
          alt="icon"
          width={24}
          height={24}
        />
      </div>

      <BottomSheetPopup show={showPopUp} onClose={() => setShowPopUp(false)}>
        <div className={stl.sharePostContainerP}>
          <h3>
            {props.reportShare
              ? t("شارك تقرير فحص", {
                ns: "web_post_view",
              })
              : t("شارك هذا الإعلان", {
                ns: "web_post_view",
              })}
          </h3>
          <div className={stl.socalBtns}>
            <a
              href={`https://www.facebook.com/sharer.php?u=${textToCopy}`}
              onClick={() => {
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Facebook",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Facebook",
                  });
                textToCopy;
              }}
              rel="noopener noreferrer" target="_blank">
              <img
                width={48}
                height={48}
                src={faceBookShareIcon}
                alt="faceBbok share"
              />
              <span>
                {t("فيسبوك", {
                  ns: "web_post_view",
                })}
              </span>
            </a>
            <a
              href={"https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fsyarah.com&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=" + createUrlAbsolute(`/cardetail/${props.postData?.details?.id}`)}
              onClick={() => {
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Twitter",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Twitter",
                  });
              }}
              rel="noopener noreferrer" target="_blank">
              <XshareSVG />
              <span>
                {t("تويتر", {
                  ns: "web_post_view"
                })}
              </span>
            </a>
            <a
              className="m-show"
              href={`whatsApp://send?text=%0A%0A ${textToCopy}`}
              onClick={() => {
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Whatsapp",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Whatsapp",
                  });
              }}
              rel="noopener noreferrer" target="_blank">
              <WhatsAppSVG />
              <span>
                {t("واتساب", {
                  ns: "web_post_view",
                })}
              </span>
            </a>
          </div>
          <div className={[stl.copyDataContainer, stl.copyLink].join(" ")}>
            <input
              ref={copyCodeRef}
              id="linkCopy"
              type="text"
              disabled=""
              readOnly
              value={decodeURI(textToCopy)}
            />
            {CopyDone ? (
              <span className={stl.doneCopyCont}>
                <img src={CDN_LINK + "/assets/images/Check.svg"} alt="done" />{" "}
                {t("تم نسخ الرابط", {
                  ns: "web_post_view",
                })}
              </span>
            ) : (
              <button
                onClick={() => {
                  props.isReport
                    ? trackEvents("inspection_share", {
                      ...props?.postData?.g4Data,
                      share_medium: "Whatsapp",
                    })
                    : trackEvents("post_share", {
                      ...props?.postData?.g4Data,
                      share_medium: "copy_link",
                    });
                  copyCodeRef.current.select();
                  document.execCommand("copy");
                  setCopyDone(true);
                }}
                className="blueBtn">
                {t("نسخ الرابط", {
                  ns: "web_post_view",
                })}
              </button>
            )}
          </div>
        </div>
      </BottomSheetPopup>
    </>
  ) : (
    <>
      <div
        className={[stl.flex, props.btnClass ? props.btnClass : undefined].join(
          " "
        )}>
        {!props.hideFavaorite && (
          <div className={stl.conatiner}>
            <AddToFavoriteButton
              isFromPostView={true}
              postId={props?.postData?.details?.id}
              className={stl.FavoriteButton}
              g4_data={props?.postData?.g4Data}
            />
            <span>{t("أضف إلى المفضلة", { ns: "web_post_view" })}</span>
          </div>
        )}
        <div
          className={stl.conatiner}
          onClick={() => {
            setShowPopUp(true);
          }}>
          <img
            width={15}
            height={16}
            className="m-hide"
            src={CDN_LINK + "/assets/bundles/share.svg"}
            alt="share"
          />
          <ShareSvg className={"m-show"} />
          <span className="m-hide">
            {props.reportShare
              ? t("شارك تقرير الفحص", { ns: "web_post_view" })
              : t("شارك الإعلان", { ns: "web_post_view" })}
          </span>
        </div>
      </div>
      <BottomSheetPopup show={showPopUp} onClose={() => setShowPopUp(false)}>
        <div className={stl.sharePostContainerP}>
          <h3>
            {props.reportShare
              ? t("شارك تقرير فحص", {
                ns: "web_post_view",
              })
              : t("شارك هذا الإعلان", {
                ns: "web_post_view",
              })}
          </h3>
          {props.carImg && props.carTitle && (
            <div className={stl.carTitle_image}>
              <div>
                <img src={props.carImg} alt={props.carTitle} />
              </div>
              <strong>{props.carTitle}</strong>
            </div>
          )}

          {props?.title && <p>{props.title}</p>}
          <div className={stl.socalBtns}>
            <a
              href={`https://www.facebook.com/sharer.php?u=${textToCopy}`}
              onClick={() => {
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Facebook",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Facebook",
                  });
                textToCopy;
              }}
              rel="noopener noreferrer" target="_blank">
              <img
                width={48}
                height={48}
                src={faceBookShareIcon}
                alt="facebbok"
              />
              <span>
                {t("فيسبوك", {
                  ns: "web_post_view",
                })}
              </span>
            </a>
            <a
              href={"https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fsyarah.com&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=" + createUrlAbsolute(`/cardetail/${props.postData?.details?.id}`)}
              onClick={() => {
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Twitter",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Twitter",
                  });
              }}
              rel="noopener noreferrer" target="_blank">
              <XshareSVG />
              <span>
                {t("تويتر", {
                  ns: "web_post_view",
                })}
              </span>
            </a>
            <a
              className="m-show"
              href={`whatsApp://send?text=%0A%0A ${textToCopy}`}
              onClick={() => {
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Whatsapp",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "Whatsapp",
                  });
              }}
              rel="noopener noreferrer" target="_blank">
              <WhatsAppSVG />
              <span>
                {t("واتساب", {
                  ns: "web_post_view",
                })}
              </span>
            </a>
          </div>
          <div className={[stl.copyDataContainer, stl.copyLink].join(" ")}>
            <input
              ref={copyCodeRef}
              id="linkCopy"
              type="text"
              disabled=""
              readOnly
              value={decodeURI(textToCopy)}
              className={stl.inputDir}
            />
            <button
              onClick={() => {
                copyCodeRef.current.select();
                props.isReport
                  ? trackEvents("inspection_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "copy_link",
                  })
                  : trackEvents("post_share", {
                    ...props?.postData?.g4Data,
                    share_medium: "copy_link",
                  });

                document.execCommand("copy");
              }}
              className="blueBtn">
              {t("نسخ الرابط", {
                ns: "web_post_view",
              })}
            </button>
          </div>
        </div>
      </BottomSheetPopup>
    </>
  );
};

export default ShareNP;
